module.exports = __webpack_public_path__ + "media/images/pen_rebeccapurple-515a0e1a.png";